import Component from './get-meta'

export default Component